const PropTypes = require('prop-types');
// @vendor
const React = require('react');

//@commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { InputSafe } = require('commonsComponents/inputSafe');

const {   
    modifyEmailClickTextBoxLink,
    repeatEmailClickTextBoxLink,
    sameEmailErrorLink,
} = require('utilities/taggingInfo/profileEditorViewTagging');

// @ helpers
const PersonalDataHelper = require('utilities/personalDataHelper');

// @constants
const { 
    REQUEST_CODE_TOP,     
    REQUEST_CODE_EMAIL_ALREADY_VALIDATED,
    REQUEST_CODE_BLOCKED_EMAIL,
} = require('constants/index');

class EditEmailForm extends React.Component {

    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getErrorMessage = this.getErrorMessage.bind(this);

    }

    componentWillMount() {
        const { actionChangeValue, immProfileEditor } = this.props;
        // If we're mounting the component and repeatEmail is set, it means it's coming back from step 2
        const repeatEmail = immProfileEditor.getIn(['steps', 0, 'email']) !== immProfileEditor.getIn(['steps', 0, 'emailInitial']);
        !repeatEmail && actionChangeValue({email: '', inProgress: false});
    }

    handleInputChange(event){
        let { value } = event.target;
        const { name } = event.target;
        const {
            actionChangeValue, 
            immProfileEditor
        } = this.props;
        const repeatEmail = immProfileEditor.getIn(['steps', 0, 'repeatEmail']);
        const newProps = {
            [name]: value,
            [`${name}Dirty`]: !!value,
            emailBlur: false,
            repeatEmailBlur: false
        };
        
        if (name === 'email' && repeatEmail){
            newProps.repeatEmail = '';
        }
        actionChangeValue(newProps);
    }

    getErrorMessage({ emailErrorMsg, requestOtpErrorStatus }) {
        let errorMsg = formatText(`profile-${emailErrorMsg}Email`);

        if(!!requestOtpErrorStatus) {
            switch(requestOtpErrorStatus) {
                case REQUEST_CODE_EMAIL_ALREADY_VALIDATED:
                    errorMsg = formatText(`profileEditForm-otp_email_error_already`);
                    break;
                case REQUEST_CODE_BLOCKED_EMAIL:
                    sameEmailErrorLink(formatText(`profileEditForm-otp_email_error_blocked`))
                    errorMsg = formatText(`profileEditForm-otp_email_error_blocked`);
                    break;
                case REQUEST_CODE_TOP:
                    errorMsg = formatText(`profileEditForm-otp_email_new_request_top`);
            }
        }
       return errorMsg;
    }

    render(){
        const {
            getValidation,
            handleBlur,
            immProfileEditor,
            immProfileFields
        } = this.props;
        const immStep = immProfileEditor.getIn(['steps', 0]);
        const currentEmail = immStep.get('emailInitial') || <FormattedText value="profileEditForm-emptyEmail" />;
        const email = immStep.get('email');
        const emailBlur = immStep.get('emailBlur');
        const emailIsValid = PersonalDataHelper.isValidEmail(email) && (PersonalDataHelper.getEmail(immProfileFields).toLowerCase() !== email.toLowerCase());
        const { emailErrorState, emailErrorMsg } = getValidation('email', email, emailBlur, emailIsValid);
        const requestOtpErrorStatus = immProfileEditor.get('requestOtpErrorStatus');

        const repeatEmail = immStep.get('repeatEmail');
        const repeatEmailBlur = immStep.get('repeatEmailBlur');
        const repeatEmailIsValid = email === repeatEmail;
        const { repeatEmailErrorState, repeatEmailErrorMsg } = getValidation('repeatEmail', repeatEmail, repeatEmailBlur, repeatEmailIsValid);

        return (
            <div>
                <div className="row">
                    <div className="col-xs-12 edit-form-step__current-data">
                        <FormattedText
                            value="profileEditForm-currentEmail"
                            className="edit-form-step__form-label edit-form-step__form-label--data-title"
                        />
                    </div>
                    <div className="col-xs-12 edit-form-step__current-data-value">{currentEmail}</div>
                </div>
                <div className="row edit-form-step__form-section--with-margin-top">
                    <div className="col-xs-6 edit-form-step__min-height-field">
                        <InputSafe
                            label={formatText('profileEditForm-newEmail')}
                            name="email"
                            onBlur={handleBlur}
                            onChange={this.handleInputChange}
                            onClick={modifyEmailClickTextBoxLink}
                            type="text"
                            value={email}
                            errorState={emailErrorState || !!requestOtpErrorStatus}
                            errorMessage={this.getErrorMessage({ emailErrorMsg, requestOtpErrorStatus })}
                        />
                    </div>
                    <div className="col-xs-6 edit-form-step__min-height-field">
                        <InputSafe
                            label={formatText('profileEditForm-newEmailRepeat')}
                            name="repeatEmail"
                            onBlur={handleBlur}
                            onChange={this.handleInputChange}
                            onClick={repeatEmailClickTextBoxLink}
                            type="text"
                            value={repeatEmail}
                            errorState={repeatEmailErrorState}
                            errorMessage={formatText(`profile-${repeatEmailErrorMsg}RepeatEmail`)}
                            disabled={!emailIsValid}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

EditEmailForm.propTypes = {
    actionChangeValue: PropTypes.func.isRequired,
    getValidation: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
    immProfileEditor: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired
};

module.exports = EditEmailForm;